import dynamic from "next/dynamic";
import { forwardRef, useState } from "react";
import Image from "next/image";

import Head from "next/head";
import Link from "next/link";
import clsx from "clsx";
const CallbackModal = dynamic(() => import("@/components/callback-modal"));

const OuterContainer = forwardRef(function OuterContainer(
  // @ts-ignore
  { className, children, ...props },
  ref
) {
  return (
    // @ts-ignore
    <div ref={ref} className={clsx("sm:px-8", className)} {...props}>
      <div className="mx-auto max-w-7xl lg:px-8">{children}</div>
    </div>
  );
});

const InnerContainer = forwardRef(function InnerContainer(
  // @ts-ignore
  { className, children, ...props },
  ref
) {
  return (
    <div
      // @ts-ignore
      ref={ref}
      className={clsx("relative px-4 sm:px-8 lg:px-12", className)}
      {...props}
    >
      <div className="mx-auto max-w-2xl lg:max-w-5xl">{children}</div>
    </div>
  );
});

export const Container = forwardRef(function Container(
  // @ts-ignore
  { children, ...props },
  ref
) {
  return (
    // @ts-ignore
    <OuterContainer ref={ref} {...props}>
      {/* @ts-ignore */}
      <InnerContainer>{children}</InnerContainer>
    </OuterContainer>
  );
});

// @ts-ignore
Container.Outer = OuterContainer;
// @ts-ignore
Container.Inner = InnerContainer;

export function formatDate(dateString) {
  return new Date(`${dateString}T00:00:00Z`).toLocaleDateString("en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
}

function ChevronRightIcon(props) {
  return (
    <svg viewBox="0 0 16 16" fill="none" aria-hidden="true" {...props}>
      <path
        d="M6.75 5.75 9.25 8l-2.5 2.25"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Card({ as: Component = "div", className, children }) {
  return (
    // @ts-ignore
    <Component
      className={clsx(className, "group relative flex flex-col items-start")}
    >
      {children}
    </Component>
  );
}

Card.Link = function CardLink({ children, ...props }) {
  return (
    <>
      {/* <div className="absolute -inset-y-2 -inset-x-4 z-0 scale-90 bg-zinc-50 opacity-0 transition group-hover:scale-95 group-hover:opacity-100 dark:bg-zinc-100/50 sm:-inset-x-6 sm:rounded-2xl cursor-pointer" /> */}
      {/* @ts-ignore */}
      <Link {...props}>
        <span className="absolute -inset-y-6 -inset-x-4 z-20 sm:-inset-x-6 sm:rounded-2xl" />
        <span className="relative z-10">{children}</span>
      </Link>
    </>
  );
};

Card.Title = function CardTitle({ as: Component = "h2", href, children }) {
  return (
    // @ts-ignore
    <Component className="text-xl font-semibold tracking-tight text-zinc-800 dark:text-zinc-800">
      {href ? <Card.Link href={href}>{children}</Card.Link> : children}
    </Component>
  );
};

Card.Description = function CardDescription({ children }) {
  return (
    <p className="relative z-10 mt-2 text-sm text-zinc-600 dark:text-zinc-700">
      {children}
    </p>
  );
};

Card.Cta = function CardCta({ children }) {
  return (
    <div
      aria-hidden="true"
      className="relative z-10 flex items-center text-sm font-medium text-brand-500"
    >
      {children}
      <ChevronRightIcon className="ml-1 h-4 w-4 stroke-current" />
    </div>
  );
};

Card.Eyebrow = function CardEyebrow({
  as: Component = "p",
  decorate = false,
  className,
  children,
  ...props
}) {
  return (
    // @ts-ignore
    <Component
      className={clsx(
        className,
        "relative z-10 order-second my-3 flex items-center text-sm text-zinc-700 dark:text-zinc-700",
        decorate && "pl-3.5"
      )}
      {...props}
    >
      {decorate && (
        <span
          className="absolute inset-y-0 left-0 flex items-center"
          aria-hidden="true"
        >
          <span className="h-full w-0.5 rounded-full bg-zinc-200 dark:bg-zinc-500" />
        </span>
      )}
      {children}
    </Component>
  );
};

export function TwitterIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path d="M20.055 7.983c.011.174.011.347.011.523 0 5.338-3.92 11.494-11.09 11.494v-.003A10.755 10.755 0 0 1 3 18.186c.308.038.618.057.928.058a7.655 7.655 0 0 0 4.841-1.733c-1.668-.032-3.13-1.16-3.642-2.805a3.753 3.753 0 0 0 1.76-.07C5.07 13.256 3.76 11.6 3.76 9.676v-.05a3.77 3.77 0 0 0 1.77.505C3.816 8.945 3.288 6.583 4.322 4.737c1.98 2.524 4.9 4.058 8.034 4.22a4.137 4.137 0 0 1 1.128-3.86A3.807 3.807 0 0 1 19 5.274a7.657 7.657 0 0 0 2.475-.98c-.29.934-.9 1.729-1.713 2.233A7.54 7.54 0 0 0 22 5.89a8.084 8.084 0 0 1-1.945 2.093Z" />
    </svg>
  );
}

export function InstagramIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path d="M12 3c-2.444 0-2.75.01-3.71.054-.959.044-1.613.196-2.185.418A4.412 4.412 0 0 0 4.51 4.511c-.5.5-.809 1.002-1.039 1.594-.222.572-.374 1.226-.418 2.184C3.01 9.25 3 9.556 3 12s.01 2.75.054 3.71c.044.959.196 1.613.418 2.185.23.592.538 1.094 1.039 1.595.5.5 1.002.808 1.594 1.038.572.222 1.226.374 2.184.418C9.25 20.99 9.556 21 12 21s2.75-.01 3.71-.054c.959-.044 1.613-.196 2.185-.419a4.412 4.412 0 0 0 1.595-1.038c.5-.5.808-1.002 1.038-1.594.222-.572.374-1.226.418-2.184.044-.96.054-1.267.054-3.711s-.01-2.75-.054-3.71c-.044-.959-.196-1.613-.419-2.185A4.412 4.412 0 0 0 19.49 4.51c-.5-.5-1.002-.809-1.594-1.039-.572-.222-1.226-.374-2.184-.418C14.75 3.01 14.444 3 12 3Zm0 1.622c2.403 0 2.688.009 3.637.052.877.04 1.354.187 1.67.31.421.163.72.358 1.036.673.315.315.51.615.673 1.035.123.317.27.794.31 1.671.043.95.052 1.234.052 3.637s-.009 2.688-.052 3.637c-.04.877-.187 1.354-.31 1.67-.163.421-.358.72-.673 1.036a2.79 2.79 0 0 1-1.035.673c-.317.123-.794.27-1.671.31-.95.043-1.234.052-3.637.052s-2.688-.009-3.637-.052c-.877-.04-1.354-.187-1.67-.31a2.789 2.789 0 0 1-1.036-.673 2.79 2.79 0 0 1-.673-1.035c-.123-.317-.27-.794-.31-1.671-.043-.95-.052-1.234-.052-3.637s.009-2.688.052-3.637c.04-.877.187-1.354.31-1.67.163-.421.358-.72.673-1.036.315-.315.615-.51 1.035-.673.317-.123.794-.27 1.671-.31.95-.043 1.234-.052 3.637-.052Z" />
      <path d="M12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-7.622a4.622 4.622 0 1 0 0 9.244 4.622 4.622 0 0 0 0-9.244Zm5.884-.182a1.08 1.08 0 1 1-2.16 0 1.08 1.08 0 0 1 2.16 0Z" />
    </svg>
  );
}

export function GitHubIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.475 2 2 6.588 2 12.253c0 4.537 2.862 8.369 6.838 9.727.5.09.687-.218.687-.487 0-.243-.013-1.05-.013-1.91C7 20.059 6.35 18.957 6.15 18.38c-.113-.295-.6-1.205-1.025-1.448-.35-.192-.85-.667-.013-.68.788-.012 1.35.744 1.538 1.051.9 1.551 2.338 1.116 2.912.846.088-.666.35-1.115.638-1.371-2.225-.256-4.55-1.14-4.55-5.062 0-1.115.387-2.038 1.025-2.756-.1-.256-.45-1.307.1-2.717 0 0 .837-.269 2.75 1.051.8-.23 1.65-.346 2.5-.346.85 0 1.7.115 2.5.346 1.912-1.333 2.75-1.05 2.75-1.05.55 1.409.2 2.46.1 2.716.637.718 1.025 1.628 1.025 2.756 0 3.934-2.337 4.806-4.562 5.062.362.32.675.936.675 1.897 0 1.371-.013 2.473-.013 2.82 0 .268.188.589.688.486a10.039 10.039 0 0 0 4.932-3.74A10.447 10.447 0 0 0 22 12.253C22 6.588 17.525 2 12 2Z"
      />
    </svg>
  );
}

export function LinkedInIcon(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path d="M18.335 18.339H15.67v-4.177c0-.996-.02-2.278-1.39-2.278-1.389 0-1.601 1.084-1.601 2.205v4.25h-2.666V9.75h2.56v1.17h.035c.358-.674 1.228-1.387 2.528-1.387 2.7 0 3.2 1.778 3.2 4.091v4.715zM7.003 8.575a1.546 1.546 0 01-1.548-1.549 1.548 1.548 0 111.547 1.549zm1.336 9.764H5.666V9.75H8.34v8.589zM19.67 3H4.329C3.593 3 3 3.58 3 4.297v15.406C3 20.42 3.594 21 4.328 21h15.338C20.4 21 21 20.42 21 19.703V4.297C21 3.58 20.4 3 19.666 3h.003z" />
    </svg>
  );
}

function Photos() {
  let rotations = [
    "rotate-2",
    "-rotate-2",
    "rotate-2",
    "rotate-2",
    "-rotate-2",
  ];

  return (
    <div className="mt-16 sm:mt-20">
      <div className="-my-4 flex justify-center gap-5 overflow-hidden py-4 sm:gap-8">
        {[
          "https://images.ctfassets.net/eo68gvto3q0j/6qcL7xdh33AS2dx9XnMzdC/65d33eac7de37f26feeffd585efdab96/IMG_0688.JPG",
          "https://images.ctfassets.net/eo68gvto3q0j/55dzmvNLOk5pkT5gbLAAat/eca5e6843b885c4143f10b3785094353/IMG_2285.JPG",
          "https://images.ctfassets.net/eo68gvto3q0j/2JSq9yNyobEFxQfHuJhatg/c3bdaefdeeeb929b13045aa3cf8b8997/IMG_2276.JPG",
          "https://images.ctfassets.net/eo68gvto3q0j/2Xw4v6OoaecADVUno6dniD/5463f7cc747572ee7283d53a70996647/IMG_2283.JPG",
          "https://images.ctfassets.net/eo68gvto3q0j/5coHuLOtEihUTBDJSMD9Vv/5819f3bf27b3f5e4b9af3f26942d4e9e/IMG_2286.JPG",
        ].map((image, imageIndex) => (
          <div
            key={image}
            className={clsx(
              "relative aspect-[9/10] w-44 flex-none overflow-hidden rounded-xl bg-zinc-100 dark:bg-zinc-800 sm:w-72 sm:rounded-2xl",
              rotations[imageIndex % rotations.length]
            )}
          >
            <Image
              src={image}
              alt=""
              fill
              sizes="(min-width: 640px) 18rem, 11rem"
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function PermanentMakeup() {
  const [state, setState] = useState({
    showCallbackModal: false,
    showOpenDayModal: false,
  });
  return (
    <>
      <Head>
        <title>
          Start A Career In Permanent Makeup in 2024 | Permanent Makeup Training
        </title>
        <meta
          name="description"
          content="Learn permanent makeup alongside our expert team of talented permanent makeup artists. Schedule a call to learn more."
        />
      </Head>
      {/* @ts-ignore */}
      <Container className="mt-12">
        {/* <div className="mx-auto mt-16 max-w-7xl px-4 sm:mt-24 sm:px-6 lg:mt-32"> */}
        <div className="lg:grid lg:grid-cols-12 lg:gap-8">
          <div className="sm:text-center md:mx-auto md:max-w-2xl lg:col-span-6 lg:text-left flex flex-col justify-center">
            <h1 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-zinc-800 sm:text-5xl">
              Start a new career in{" "}
              <span className="text-brand-600">Permanent Makeup</span> in 2024
            </h1>
            <p className="mt-6 text-base text-zinc-800 dark:text-zinc-800">
              Are you looking to become a permanent makeup artist. Then look no
              further!
              <br />
              <br />
              We are the training center you need to start, build and grow your
              career in permanent makeup.
            </p>
            <div className="flex justify-between mt-4">
              {/* @ts-ignore */}
              {/* <button
              onClick={() => {
                setState({ ...state, showCallbackModal: true });
              }}
              className="mt-2 mx-auto lg:mx-0 flex items-center justify-center px-5 py-3 border border-transparent shadow text-base font-medium rounded-md text-white bg-brand-600 hover:bg-brand-900"
            >
              Book a call with a PMU tutor
            </button> */}
            </div>
          </div>
          <div className="relative mt-12 sm:mx-auto sm:max-w-lg lg:col-span-6 lg:mx-0 lg:mt-0 lg:flex lg:max-w-none lg:items-center">
            <svg
              className="absolute top-0 left-1/2 origin-top -translate-x-1/2 -translate-y-8 scale-75 transform sm:scale-100 lg:hidden"
              width={640}
              height={784}
              fill="none"
              viewBox="0 0 640 784"
              aria-hidden="true"
            >
              <defs>
                <pattern
                  id="4f4f415c-a0e9-44c2-9601-6ded5a34a13e"
                  x={118}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x={0}
                    y={0}
                    width={4}
                    height={4}
                    className="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                y={72}
                width={640}
                height={640}
                className="text-gray-50"
                fill="currentColor"
              />
              <rect
                x={118}
                width={404}
                height={784}
                fill="url(#4f4f415c-a0e9-44c2-9601-6ded5a34a13e)"
              />
            </svg>
            <div className="sticky top-0 mx-auto w-full rounded-lg shadow-lg lg:max-w-md">
              <div className="relative block w-full overflow-hidden rounded-lg bg-white focus:outline-none ring-2 ring-brand-500 ring-offset-2">
                <div className="p-4 text-center">
                  <h3 className="text-xl font-bold tracking-tight text-gray-900 dark:text-zinc-800">
                    Permanent Makeup Open Days
                  </h3>
                  {/* <h4 className="text-xl font-bold tracking-tight text-gray-900 dark:text-zinc-800">
                    13th, 20th & 27th of Jan
                  </h4>
                  <h4 className="text-xl font-bold tracking-tight text-gray-900 dark:text-zinc-800">
                    7th, 14th & 21st of Feb
                  </h4> */}
                  <p className="mt-2 text-gray-600 text-base">
                    Come and join us to for presentations and Q&A sessions to
                    discuss permanent makeup training in 2024 with our expert
                    tutors.
                  </p>
                  <div>
                    <button
                      onClick={() => {
                        setState({
                          ...state,
                          showOpenDayModal: true,
                          showCallbackModal: false,
                        });
                      }}
                      className="mt-2 mx-auto flex items-center justify-center px-5 py-3 border border-transparent shadow text-base font-medium rounded-md text-white bg-brand-600 hover:bg-brand-900"
                    >
                      Register
                    </button>
                  </div>
                </div>
                {/* <span className="sr-only">Watch our video to learn more</span>
              <img
                className="w-full"
                src="https://images.ctfassets.net/eo68gvto3q0j/55dzmvNLOk5pkT5gbLAAat/eca5e6843b885c4143f10b3785094353/IMG_2285.JPG"
                alt=""
              />
              <span
                className="absolute inset-0 flex h-full w-full items-center justify-center"
                aria-hidden="true"
              >
                <svg
                  className="h-20 w-20 text-brand-500"
                  fill="currentColor"
                  viewBox="0 0 84 84"
                >
                  <circle opacity="0.9" cx={42} cy={42} r={42} fill="white" />
                  <path d="M55.5039 40.3359L37.1094 28.0729C35.7803 27.1869 34 28.1396 34 29.737V54.263C34 55.8604 35.7803 56.8131 37.1094 55.9271L55.5038 43.6641C56.6913 42.8725 56.6913 41.1275 55.5039 40.3359Z" />
                </svg>
              </span> */}
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Photos />
      {/* @ts-ignore */}
      <Container className="mt-24 md:mt-28 pb-6">
        <div className="mx-auto grid max-w-xl grid-cols-1 gap-y-20 lg:max-w-none lg:grid-cols-2">
          <div className="flex flex-col gap-12">
            <h2 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-zinc-800 sm:text-2xl">
              Learn permanent makeup alongside our expert team of talented
              permanent makeup artists
            </h2>
            <p className="-mt-8 text-gray-500">
              Our training covers all aspects you need to know to establish
              yourself in a new career with a strong emphasis on developing
              practical skills and techniques.
            </p>
            <div className="flex flex-col divide-y divide-gray-200">
              {/* @ts-ignore */}
              <Card as="article" className="pb-6">
                <Card.Title
                  href={
                    "https://www.cosmetic.college/courses/vtct/level-4-certificate-in-micropigmentation/"
                  }
                >
                  VTCT Level 4 Micropigmentation
                </Card.Title>
                <div className="relative text-base w-full mx-auto max-w-prose lg:max-w-none my-2">
                  <figure>
                    <div className="aspect-w-12 aspect-h-7 rounded-lg shadow-lg">
                      <video
                        src="https://videos.ctfassets.net/eo68gvto3q0j/3LLD0tqPlnvPp1kYMMS5hv/9d4432802d3cd9bf56adfb4da900e382/ombre-opt.mp4"
                        autoPlay
                        playsInline
                        muted
                        loop
                        controls
                        controlsList="nodownload nofullscreen noremoteplayback"
                        onContextMenu={() => false}
                        className="rounded-lg shadow-lg object-cover object-center"
                      ></video>
                    </div>
                    <figcaption className="sr-only mt-3 flex text-sm text-gray-500">
                      <span className="ml-2">
                        VTCT Level 4 Micropigmentation
                      </span>
                    </figcaption>
                  </figure>
                </div>
                {/* @ts-ignore */}
                <Card.Eyebrow decorate>
                  Industry leading qualification for permanent makeup artists to
                  begin and grow their career.
                </Card.Eyebrow>
                <Card.Description>
                  Train alongside our permanent makeup artists to get started in
                  a new career and upgrade your skills
                </Card.Description>
                <div className="flex mt-4 w-full items-end">
                  <div className="flex-1">
                    <p className="relative z-10 text-sm flex-1">
                      <span className="font-semibold tracking-tight text-zinc-800 dark:text-zinc-800">
                        Course Fees:
                      </span>{" "}
                      <span className="block">
                        Was: <span className="font-semibold mr-2">£5,000</span>
                        Now: <span className="font-semibold">£2,500</span>
                      </span>
                    </p>
                  </div>
                  <div>
                    <Card.Cta>Learn more</Card.Cta>
                  </div>
                </div>
              </Card>
              {/* @ts-ignore */}
              <Card as="article" className="py-6">
                <Card.Title
                  href={
                    "https://www.cosmetic.college/courses/vtct/level-4-certificate-in-enhancing-eyebrows-with-microblading-techniques/"
                  }
                >
                  VTCT Level 4 Microblading
                </Card.Title>
                <div className="relative text-base w-full mx-auto max-w-prose lg:max-w-none my-2">
                  <figure>
                    <div className="aspect-w-12 aspect-h-7 rounded-lg shadow-lg">
                      <video
                        src="https://videos.ctfassets.net/eo68gvto3q0j/2HhSaTvYkmLwUoJiOtM2Mu/260f077ffba6e52655b1b4f219dd9100/microblading-opt.mp4"
                        autoPlay
                        playsInline
                        muted
                        loop
                        controls
                        controlsList="nodownload nofullscreen noremoteplayback"
                        onContextMenu={() => false}
                        className="rounded-lg shadow-lg object-cover object-center"
                      ></video>
                    </div>
                    <figcaption className="sr-only mt-3 flex text-sm text-gray-500">
                      <span className="ml-2">VTCT Level 4 Microblading</span>
                    </figcaption>
                  </figure>
                </div>
                {/* @ts-ignore */}
                <Card.Eyebrow decorate>
                  Nationally recognised qualification for microblading artists
                </Card.Eyebrow>
                <Card.Description>
                  Train alongside our permanent makeup artists to get started in
                  a new career and upgrade your skills
                </Card.Description>
                <div className="flex mt-4 w-full items-end">
                  <div className="flex-1">
                    <p className="relative z-10 text-sm flex-1">
                      <span className="font-semibold tracking-tight text-zinc-800 dark:text-zinc-800">
                        Course Fees:
                      </span>{" "}
                      <span className="block">
                        Was: <span className="font-semibold mr-2">£2,450</span>
                        Now: <span className="font-semibold">£1,750</span>
                      </span>
                    </p>
                  </div>
                  <div>
                    <Card.Cta>Learn more</Card.Cta>
                  </div>
                </div>
              </Card>
              {/* @ts-ignore */}
              <Card as="article" className="py-6">
                <Card.Title
                  href={
                    "https://www.cosmetic.college/courses/vtct/level-4-micropigmentation-conversion-training-course/"
                  }
                >
                  VTCT Level 4 Micropigmentation Conversion
                </Card.Title>
                <div className="relative text-base w-full mx-auto max-w-prose lg:max-w-none my-2">
                  <figure>
                    <div className="aspect-w-12 aspect-h-7 rounded-lg shadow-lg">
                      <video
                        src="https://videos.ctfassets.net/eo68gvto3q0j/1GmnXQ0rnATh8ytoCcoE1Y/18ca215d278ebf11fb59fb2d9e10f8c7/Untitled_design.mp4"
                        autoPlay
                        playsInline
                        muted
                        loop
                        controls
                        controlsList="nodownload nofullscreen noremoteplayback"
                        onContextMenu={() => false}
                        className="rounded-lg shadow-lg object-cover object-center"
                      ></video>
                    </div>
                    <figcaption className="sr-only mt-3 flex text-sm text-gray-500">
                      <span className="ml-2">
                        VTCT Level 4 Micropigmentation Conversion
                      </span>
                    </figcaption>
                  </figure>
                </div>
                {/* @ts-ignore */}
                <Card.Eyebrow decorate>
                  Convert accredited training into nationally recognised
                  qualifications
                </Card.Eyebrow>
                <Card.Description>
                  Train alongside our permanent makeup artists to get started in
                  a new career and upgrade your skills
                </Card.Description>
                <div className="flex mt-4 w-full items-end">
                  <div className="flex-1">
                    <p className="relative z-10 text-sm flex-1">
                      <span className="font-semibold tracking-tight text-zinc-800 dark:text-zinc-800">
                        Course Fees:
                      </span>{" "}
                      <span className="block">
                        Was: <span className="font-semibold mr-2">£1,499</span>
                        Now: <span className="font-semibold">£999</span>
                      </span>
                    </p>
                  </div>
                  <div>
                    <Card.Cta>Learn more</Card.Cta>
                  </div>
                </div>
              </Card>
            </div>
            <h2 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-zinc-800 sm:text-2xl">
              Push your skills and career further with our advanced accredited
              masterclasses
            </h2>
            <div className="flex flex-col divide-y divide-gray-200">
              {/* @ts-ignore */}
              <Card as="article" className="py-6">
                <Card.Title
                  href={
                    "https://www.cosmetic.college/courses/semi-permanent-makeup/ombre-brows/"
                  }
                >
                  Ombre Brows
                </Card.Title>
                <div className="relative text-base w-full mx-auto max-w-prose lg:max-w-none my-2">
                  <figure>
                    <div className="aspect-w-12 aspect-h-7 rounded-lg shadow-lg">
                      <video
                        src="https://videos.ctfassets.net/eo68gvto3q0j/3LLD0tqPlnvPp1kYMMS5hv/9d4432802d3cd9bf56adfb4da900e382/ombre-opt.mp4"
                        autoPlay
                        playsInline
                        muted
                        loop
                        controls
                        controlsList="nodownload nofullscreen noremoteplayback"
                        onContextMenu={() => false}
                        className="rounded-lg shadow-lg object-cover object-center"
                      ></video>
                    </div>
                    <figcaption className="sr-only mt-3 flex text-sm text-gray-500">
                      <span className="ml-2">
                        Ombre Brows Permanent Makeup Training At The Cosmetic
                        College
                      </span>
                    </figcaption>
                  </figure>
                </div>
                {/* @ts-ignore */}
                <Card.Eyebrow decorate>
                  Leveraging shading to produce a soft, ombré effect for brows
                  that wow
                </Card.Eyebrow>
                <Card.Description>
                  Delivered by true industry experts in the Ombre Brows
                  technique - train today to grow your career
                </Card.Description>
                <div className="flex mt-4 w-full items-end">
                  <div className="flex-1">
                    <p className="relative z-10 text-sm flex-1">
                      <span className="font-semibold tracking-tight text-zinc-800 dark:text-zinc-800">
                        Course Fees:
                      </span>{" "}
                      <span className="block">
                        Was: <span className="font-semibold mr-2">£1,500</span>
                        Now: <span className="font-semibold">£750</span>
                      </span>
                    </p>
                  </div>
                  <div>
                    <Card.Cta>Learn more</Card.Cta>
                  </div>
                </div>
              </Card>
              {/* @ts-ignore */}
              <Card as="article" className="py-6">
                <Card.Title
                  href={
                    "https://www.cosmetic.college/courses/semi-permanent-makeup/3d-hairstroke-brows/"
                  }
                >
                  3D Hairstroke Brows
                </Card.Title>
                <div className="relative text-base w-full mx-auto max-w-prose lg:max-w-none my-2">
                  <figure>
                    <div className="aspect-w-12 aspect-h-7 rounded-lg shadow-lg">
                      <video
                        src="https://videos.ctfassets.net/eo68gvto3q0j/1GmnXQ0rnATh8ytoCcoE1Y/18ca215d278ebf11fb59fb2d9e10f8c7/Untitled_design.mp4"
                        autoPlay
                        playsInline
                        muted
                        loop
                        controls
                        controlsList="nodownload nofullscreen noremoteplayback"
                        onContextMenu={() => false}
                        className="rounded-lg shadow-lg object-cover object-center"
                      ></video>
                    </div>
                    <figcaption className="sr-only mt-3 flex text-sm text-gray-500">
                      <span className="ml-2">
                        3D Hairstroke Permanent Makeup Brows Training At The
                        Cosmetic College
                      </span>
                    </figcaption>
                  </figure>
                </div>
                {/* @ts-ignore */}
                <Card.Eyebrow decorate>
                  Create a natural, hair-like effects that last for your clients
                </Card.Eyebrow>
                <Card.Description>
                  Expand your permanent makeup skills and become a specialist in
                  3D Hairstrokes
                </Card.Description>
                <div className="flex mt-4 w-full items-end">
                  <div className="flex-1">
                    <p className="relative z-10 text-sm flex-1">
                      <span className="font-semibold tracking-tight text-zinc-800 dark:text-zinc-800">
                        Course Fees:
                      </span>{" "}
                      <span className="block">
                        Was: <span className="font-semibold mr-2">£1,500</span>
                        Now: <span className="font-semibold">£750</span>
                      </span>
                    </p>
                  </div>
                  <div>
                    <Card.Cta>Learn more</Card.Cta>
                  </div>
                </div>
              </Card>
              {/* @ts-ignore */}
              <Card as="article" className="py-6">
                <Card.Title
                  href={
                    "https://www.cosmetic.college/courses/semi-permanent-makeup/eyeliner-and-lash-enhancements/"
                  }
                >
                  Eyeliner & Lash Enhancement
                </Card.Title>
                <div className="relative w-full aspect-w-16 aspect-h-9 my-4 rounded-lg shadow-lg">
                  <img
                    src="https://images.ctfassets.net/eo68gvto3q0j/55dzmvNLOk5pkT5gbLAAat/eca5e6843b885c4143f10b3785094353/IMG_2285.JPG"
                    className="absolute inset-0 object-cover object-center rounded-lg"
                  />
                </div>
                {/* @ts-ignore */}
                <Card.Eyebrow decorate>
                  Train alongside our permanent makeup artists to get started in
                  a new career and upgrade your skills
                </Card.Eyebrow>
                <Card.Description>
                  Using a variety of techniques, from a strong liner to a subtle
                  lash enhancement, our permanent eyeliner techniques provide
                  your clients with a long-lasting look
                </Card.Description>
                <div className="flex mt-4 w-full items-end">
                  <div className="flex-1">
                    <p className="relative z-10 text-sm flex-1">
                      <span className="font-semibold tracking-tight text-zinc-800 dark:text-zinc-800">
                        Course Fees:
                      </span>{" "}
                      <span className="block">
                        Was: <span className="font-semibold mr-2">£1,500</span>
                        Now: <span className="font-semibold">£750</span>
                      </span>
                    </p>
                  </div>
                  <div>
                    <Card.Cta>Learn more</Card.Cta>
                  </div>
                </div>
              </Card>
              {/* @ts-ignore */}
              <Card as="article" className="py-6">
                <Card.Title
                  href={
                    "https://www.cosmetic.college/courses/semi-permanent-makeup/lip-blush-training/"
                  }
                >
                  Lip Blush & Lip Liner
                </Card.Title>
                <div className="relative text-base w-full mx-auto max-w-prose lg:max-w-none my-2">
                  <figure>
                    <div className="aspect-w-12 aspect-h-7 rounded-lg shadow-lg">
                      <video
                        src="https://videos.ctfassets.net/eo68gvto3q0j/4IdVO6N8bDyvM8JTXHgyy2/5d2baacefc5349c7e37f975a4f024473/lip-blush-opt.mp4"
                        autoPlay
                        playsInline
                        muted
                        loop
                        controls
                        controlsList="nodownload nofullscreen noremoteplayback"
                        onContextMenu={() => false}
                        className="rounded-lg shadow-lg object-cover object-center"
                      ></video>
                    </div>
                    <figcaption className="sr-only mt-3 flex text-sm text-gray-500">
                      <span className="ml-2">
                        Lip Blush Permanent Makeup Training At The Cosmetic
                        College
                      </span>
                    </figcaption>
                  </figure>
                </div>
                {/* @ts-ignore */}
                <Card.Eyebrow decorate>
                  Give clients permanent lip makeup without the stress and fuss
                  of daily application
                </Card.Eyebrow>
                <Card.Description>
                  On our Lip Blush & Liner training course you will learn how to
                  create smudge proof lip liner and how to master a lip blush
                </Card.Description>
                <div className="flex mt-4 w-full items-end">
                  <div className="flex-1">
                    <p className="relative z-10 text-sm flex-1">
                      <span className="font-semibold tracking-tight text-zinc-800 dark:text-zinc-800">
                        Course Fees:
                      </span>{" "}
                      <span className="block">
                        Was: <span className="font-semibold mr-2">£1,500</span>
                        Now: <span className="font-semibold">£750</span>
                      </span>
                    </p>
                  </div>
                  <div>
                    <Card.Cta>Learn more</Card.Cta>
                  </div>
                </div>
              </Card>
              {/* @ts-ignore */}
              <Card as="article" className="py-6">
                <Card.Title
                  href={
                    "https://www.cosmetic.college/courses/semi-permanent-makeup/areola-micropigmentation/"
                  }
                >
                  Areola Micropigmentation
                </Card.Title>
                <div className="relative w-full aspect-w-16 aspect-h-9 my-4 rounded-lg shadow-lg">
                  <img
                    src="https://images.ctfassets.net/eo68gvto3q0j/3IyKAS7aVNGMd3y2lb5no9/9b8544874814e9ede5ba83e1b13f7b88/areola-restoration.jpeg"
                    className="absolute inset-0 object-cover object-center rounded-lg"
                  />
                </div>
                {/* @ts-ignore */}
                <Card.Eyebrow decorate>
                  Train with our talented permanent makeup artists and areola
                  treatment experts
                </Card.Eyebrow>
                <Card.Description>
                  Learn how to visually improve scarring and areola asymmetries
                  resulting from breast reduction and uplift surgical
                  procedures.
                </Card.Description>
                <div className="flex mt-4 w-full items-end">
                  <div className="flex-1">
                    <p className="relative z-10 text-sm flex-1">
                      <span className="font-semibold tracking-tight text-zinc-800 dark:text-zinc-800">
                        Course Fees:
                      </span>{" "}
                      <span className="block">
                        Was: <span className="font-semibold mr-2">£1,500</span>
                        Now: <span className="font-semibold">£750</span>
                      </span>
                    </p>
                  </div>
                  <div>
                    <Card.Cta>Learn more</Card.Cta>
                  </div>
                </div>
              </Card>
              {/* @ts-ignore */}
              <Card as="article" className="py-6">
                <Card.Title
                  href={
                    "https://www.cosmetic.college/courses/semi-permanent-makeup/semi-permanent-makeup-saline-removal/"
                  }
                >
                  Permanent Makeup Removal & Correction
                </Card.Title>
                <div className="relative w-full aspect-w-16 aspect-h-9 my-4 rounded-lg shadow-lg">
                  <img
                    src="https://images.ctfassets.net/eo68gvto3q0j/2QU4cNglVqpy16FTmdiwFp/eb5c2d68de247e6d60d5dc8125fba167/IMG_2286.JPG"
                    className="absolute inset-0 object-cover object-center rounded-lg"
                  />
                </div>
                {/* @ts-ignore */}
                <Card.Eyebrow decorate>
                  Learn how to remove and correct unwanted permanent makeup and
                  tattoos.
                </Card.Eyebrow>
                <Card.Description>
                  Knowing how to remove or correct permanent makeup work is an
                  essential skill for all permanent makeup artists.
                </Card.Description>
                <div className="flex mt-4 w-full items-end">
                  <div className="flex-1">
                    <p className="relative z-10 text-sm flex-1">
                      <span className="font-semibold tracking-tight text-zinc-800 dark:text-zinc-800">
                        Course Fees:
                      </span>{" "}
                      <span className="block">
                        Was: <span className="font-semibold mr-2">£500</span>
                        Now: <span className="font-semibold">£350</span>
                      </span>
                    </p>
                  </div>
                  <div>
                    <Card.Cta>Learn more</Card.Cta>
                  </div>
                </div>
              </Card>
              <div className="mt-8 relative block w-full overflow-hidden rounded-lg bg-white focus:outline-none ring-2 ring-brand-500 ring-offset-2">
                <div className="p-4">
                  <h3 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-zinc-800 sm:text-2xl">
                    Need more information
                  </h3>
                  <p className="text-gray-700 text-sm mt-2">
                    Check out our latest blog post giving more information
                    regarding our{" "}
                    <Link
                      href="https://www.cosmetic.college/blog/starting-a-career-in-permanent-makeup/"
                      className="text-brand-600 font-medium"
                    >
                      permanent makeup training courses at the Cosmetic College
                    </Link>{" "}
                    or
                  </p>
                  <button
                    onClick={() => {
                      setState({ ...state, showCallbackModal: true });
                    }}
                    className="my-4 mx-auto sm:mx-0 flex items-center justify-center px-4 py-2 border border-transparent shadow text-sm font-medium rounded-md text-white bg-brand-600 hover:bg-brand-900 float-right"
                  >
                    Schedule a call with a PMU tutor
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="space-y-8 lg:pl-16 xl:pl-24">
            <div className="relative block w-full overflow-hidden rounded-lg bg-white focus:outline-none ring-2 ring-brand-500 ring-offset-2">
              <div className="p-4">
                <h3 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-zinc-800 sm:text-2xl">
                  Permanent Makeup Business Package
                </h3>
                <p className="text-gray-700 text-sm mt-2">
                  This package is especially designed for those who wish to
                  train and start their own permanent makeup business.
                </p>
                <p className="text-gray-700 text-sm mt-2">
                  This package includes:
                </p>
                <ul className="mt-4 space-y-5 lg:space-y-0 lg:grid lg:grid-cols-1 lg:gap-x-8 lg:gap-y-2">
                  <li className="flex items-start lg:col-span-1">
                    <div className="shrink-0">
                      <svg
                        className="h-5 w-5 text-brand-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    <span className="block ml-3 text-sm text-gray-700">
                      8 qualifications
                    </span>
                  </li>
                  <li className="flex items-start lg:col-span-1">
                    <div className="shrink-0">
                      <svg
                        className="h-5 w-5 text-brand-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    <span className="block ml-3 text-sm text-gray-700">
                      Professional Treatment Starter Kits
                    </span>
                  </li>
                  <li className="flex items-start lg:col-span-1">
                    <div className="shrink-0">
                      <svg
                        className="h-5 w-5 text-brand-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    <span className="block ml-3 text-sm text-gray-700">
                      Access to our online community support groups
                    </span>
                  </li>
                  <li className="flex items-start lg:col-span-1">
                    <div className="shrink-0">
                      <svg
                        className="h-5 w-5 text-brand-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    <span className="block ml-3 text-sm text-gray-700">
                      Website
                    </span>
                  </li>
                  <li className="flex items-start lg:col-span-1">
                    <div className="shrink-0">
                      <svg
                        className="h-5 w-5 text-brand-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    <span className="block ml-3 text-sm text-gray-700">
                      Business advice and setup support
                    </span>
                  </li>
                  <li className="flex items-start lg:col-span-1">
                    <div className="shrink-0">
                      <svg
                        className="h-5 w-5 text-brand-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    <span className="block ml-3 text-sm text-gray-700">
                      3 months FREE business management and booking platform
                    </span>
                  </li>
                  <li className="flex items-start lg:col-span-1">
                    <div className="shrink-0">
                      <svg
                        className="h-5 w-5 text-brand-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    <span className="block ml-3 text-sm text-gray-700">
                      Unlimited tutor shadow/support days
                    </span>
                  </li>
                  <li className="flex items-start lg:col-span-1">
                    <div className="shrink-0">
                      <svg
                        className="h-5 w-5 text-brand-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    <span className="block ml-3 text-sm text-gray-700">
                      Refreshments &amp; snacks
                    </span>
                  </li>
                  <li className="flex items-start lg:col-span-1">
                    <div className="shrink-0">
                      <svg
                        className="h-5 w-5 text-brand-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    <span className="block ml-3 text-sm text-gray-700">
                      Complimentary treatments for your models
                    </span>
                  </li>
                </ul>
                <div className="flex mt-4 w-full items-end">
                  <div className="flex-1">
                    <p className="relative z-10 text-sm flex-1">
                      <span className="font-semibold tracking-tight text-zinc-800 dark:text-zinc-800">
                        Package Price:
                      </span>{" "}
                      <span className="block">
                        Was: <span className="font-semibold mr-2">£12,000</span>
                        Now: <span className="font-semibold">£7,500</span>
                      </span>
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => {
                    setState({ ...state, showCallbackModal: true });
                  }}
                  className="my-4 mx-auto sm:mx-0 flex items-center justify-center px-4 py-2 border border-transparent shadow text-sm font-medium rounded-md text-white bg-brand-600 hover:bg-brand-900 float-right"
                >
                  Get Started
                </button>
              </div>
            </div>
            <span className="block aspect-w-16 aspect-h-9 mt-16 rounded-lg overflow-hidden">
              <iframe
                className="w-full"
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/WzafffMKKmg?modestbranding=1"
                title="YouTube video player"
                frameBorder="0"
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </span>
          </div>
        </div>
      </Container>
      <Photos />
      <div className="md:mb-16" />
      {state.showCallbackModal && (
        <CallbackModal
          eventCategory="Permanent Makeup"
          showCallbackModal={state.showCallbackModal}
          setShow={setState}
        />
      )}
      {state.showOpenDayModal && (
        <CallbackModal
          eventCategory="Permanent Makeup"
          showCallbackModal={state.showOpenDayModal}
          setShow={setState}
          type="open-day"
          title="Open Day Registration"
        />
      )}
    </>
  );
}
